import { ApplicationState } from '@app/store'
import {
  IGlobalConfigurationState,
  IGlobalDevelopmentProjectClients,
  selectConfiguration,
  selectDevelopmentSiteMetadata,
} from '@app/store/modules/global'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { createStructuredSelector } from 'reselect'
import SiteListPage from '../components/SiteListPage'
import {
  actionCreators,
  ISiteListState,
  selectCity,
  selectClient,
  selectClientId,
  selectError,
  selectFilterText,
  selectIsLoading,
  selectItems,
  selectSort,
  selectStatus,
  selectSuggestions,
  selectTotalItems,
} from '../modules/siteList'

export default withRouter(
  connect(
    createStructuredSelector<
      ApplicationState,
      ISiteListState &
        IGlobalConfigurationState &
        IGlobalDevelopmentProjectClients
    >({
      city: selectCity(),
      client: selectClient(),
      clientSlug: selectClientId(),
      configuration: selectConfiguration(),
      developmentSiteMetadata: selectDevelopmentSiteMetadata(),
      error: selectError(),
      filterText: selectFilterText(),
      isLoading: selectIsLoading(),
      items: selectItems(),
      sortOrder: selectSort(),
      status: selectStatus(),
      suggestions: selectSuggestions(),
      totalItems: selectTotalItems(),
    }),
    actionCreators,
  )(SiteListPage),
)
